/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StatContent } from '../../models/stat-content';

export interface ApiMasterStatContentGetByIdGet$Params {
  id?: string;
}

export function apiMasterStatContentGetByIdGet(http: HttpClient, rootUrl: string, params?: ApiMasterStatContentGetByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StatContent>> {
  const rb = new RequestBuilder(rootUrl, apiMasterStatContentGetByIdGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StatContent>;
    })
  );
}

apiMasterStatContentGetByIdGet.PATH = '/api/Master/StatContent/GetById';
